<section class="searchbar">

    <div class="cab-form" style="z-index: 100;">
        <!-- افزودن سفر -->
        <div class="mails_list">

            <div class="d-flex justify-content-center">

                <div class="write_mail w-100">

                    <form [formGroup]="mdl_TripSAD" class="modal-body p-3">

                        <ng-container>
                            <!-- آدرس -->
                            <div class="central mb-2 form_box flex-column mx-2">
                                <!-- آدرس مبداء -->
                                <div class="position-relative col-12 mb-3">
                                    <input class="form-control p-2 input-start"
                                        [placeholder]="isRequestingLocation ? 'درحال دریافت موقعیت فعلی شما...' : 'آدرس دقیق مبداء شامل شهر، خیابان ...'"
                                        formControlName="strSAddress" (keydown.enter)="$event.preventDefault()">
                                    <button class="btn btn-warning rounded" (click)="show_Map('strSAddress')">
                                        <ng-container *ngIf="isRequestingLocation;else getUserLocationIcon">
                                            <i class="fa fa-spinner fa-spin fa-lg " aria-hidden="true"></i>
                                        </ng-container>
                                        <ng-template #getUserLocationIcon>
                                            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                        </ng-template>
                                    </button>
                                </div>
                                <!-- آدرس مقصد -->
                                <div class="position-relative col-12 mb-2">
                                    <input class="form-control p-2 input-start"
                                        placeholder="آدرس دقیق مقصد شامل شهر، خیابان ..." formControlName="strDAddress"
                                        (keydown.enter)="$event.preventDefault()">
                                    <button class="btn btn-warning rounded" (click)="show_Map('strDAddress')">
                                        <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <!-- کامپوننت نقشه -->
                                <app-custom-map *ngIf="showCustom_Map" [isOpenModal]="true"
                                    [strValue]="mdl_Map.get('strAddress')?.value"
                                    [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]"
                                    (mdl_Submit)="submitMap($event)">
                                </app-custom-map>


                            </div>

                            <!-- نوع جرثقیل -->
                            <div [formGroup]="mdl_TripSAD" class="central home_options mb-3">

                                <!-- زنجیری -->

                                <div class="central justify-content-start my-1 mx-2">

                                    <label class="radio-label" for="furnished-5">

                                        <input type="radio" id="furnished-5" formControlName="tiMobileGroup" [value]="2"
                                            style="display: none;">

                                        <img loading="lazy" class="fill" src="../../../assets/imgs/car-sedan-fill.png"
                                            alt="امداد زنجیری">

                                        <img loading="lazy" class="nofill" src="../../../assets/imgs/car-sedan.png"
                                            alt="امداد زنجیری">

                                        <p>زنجیری</p>

                                    </label>

                                </div>

                                <!-- چرخ گیر -->

                                <div class="central justify-content-start my-1 mx-2">

                                    <label class="radio-label" for="furnished-0">

                                        <input type="radio" id="furnished-0" formControlName="tiMobileGroup" [value]="1"
                                            style="display: none;">

                                        <img loading="lazy" class="fill" src="../../../assets/imgs/eco-fill.png"
                                            alt="امداد چرخ گیر">

                                        <img loading="lazy" class="nofill" src="../../../assets/imgs/car-eco.png"
                                            alt="امداد چرخ گیر">

                                        <p>چرخ گیر</p>

                                    </label>

                                </div>

                                <!-- کفی بر -->

                                <div class="central justify-content-start my-1 mx-2">

                                    <label class="radio-label" for="furnished-1">

                                        <input type="radio" id="furnished-1" formControlName="tiMobileGroup" [value]="3"
                                            style="display: none;">

                                        <img loading="lazy" class="fill" src="../../../assets/imgs/car-lux-fill.png"
                                            alt="امداد کفی بر">

                                        <img loading="lazy" class="nofill" src="../../../assets/imgs/car-lux.png"
                                            alt="امداد کفی بر">

                                        <p> کفی بر </p>

                                    </label>

                                </div>

                            </div>

                            <!-- برآورد هزینه -->
                            <div *ngIf="list_PreOrder?.iRent"
                                class="form_box central w-100 my-2 flex-column justify-content-between px-2">

                                <!-- محاسبه هزینه -->
                                <div class="alert alert-success w-100 row gx-0 gy-0 gy-md-0" role="alert">

                                    <!-- مدت زمان -->
                                    <div class="col-12 col-md-auto px-md-2 pb-2 pb-md-0">

                                        مدت : <b>{{list_PreOrder.strTime | faNum}} ساعت </b>

                                    </div>

                                    <!-- مسافت -->
                                    <div class="col-12 col-md-auto px-md-2 pb-2 pb-md-0">

                                        مسافت : <b>{{list_PreOrder.fKm | faNum}} کیلومتر </b>

                                    </div>

                                    <!-- هزینه -->
                                    <div class="col-12 col-md-auto px-md-2 pb-2 pb-md-0">

                                        هزینه : <b>{{list_PreOrder.iRent | number: '1.0-0' | faNum}} ریال</b>

                                    </div>

                                </div>

                            </div>

                            <!-- دکمه ها -->
                            <div class="central w-100 flex-column align-items-start price_offer">

                                <div class="row gx-0 gy-2 gy-md-0 my-2 w-100">

                                    <!-- برآورد هزینه -->
                                    <div class="col-12 col-md-auto px-md-1">
                                        <button (click)="serviceCalc()" class="w-100 btn btn-secondary px-2">
                                            <i class="fa fa-calculator fa-lg" aria-hidden="true"></i>
                                            <small> برآورد هزینه </small>
                                        </button>
                                    </div>

                                    <!--  درخواست حمل  -->
                                    <div class="col-12 col-md-auto px-md-1">
                                        <button *ngIf="!isLogin" (click)="login('new-request')"
                                            class="w-100 btn btn-primary px-2">
                                            <i class="fa fa-chain fa-lg" aria-hidden="true"></i>
                                            <small> درخواست حمل </small>
                                        </button>

                                        <button *ngIf="isLogin" routerLink="/new-request"
                                            class="w-100 btn btn-primary px-2">
                                            <i class="fa fa-chain fa-lg" aria-hidden="true"></i>
                                            <small> درخواست حمل </small>
                                        </button>
                                    </div>

                                    <!-- نمایش مسیر  -->
                                    <div *ngIf="isRoute_Hide()" class="col-12 col-md-auto px-md-1">
                                        <button class="w-100 btn btn-outline-secondary px-2" (click)="openRoute()">
                                            <i class="fa fa-road fa-lg" aria-hidden="true"></i>
                                            <small> نمایش مسیر </small>
                                        </button>
                                    </div>

                                    <!-- تعمیرگاه‌های اطراف شما  -->
                                    <div class="col-12 col-md-auto px-md-1">
                                        <button class="w-100 btn btn-outline-secondary px-2" (click)="openNearby()">
                                            <i class="fa fa-location-arrow fa-lg" aria-hidden="true"></i>
                                            <small> تعمیرگاه‌های اطراف شما </small>
                                        </button>
                                    </div>

                                    <!-- مدال ترسیم مسیر -->
                                    <app-custom-map *ngIf="isRoute_Hide() && bRouteModal" [isOpenModal]="true"
                                        [isDrawRoute]="true" [isShowAll]="false"
                                        [objRoute]="mdl_TripSAD.get('ObjResponse')?.value"
                                        [sLonLat]="[mdl_TripSAD.get('fSLon')?.value,mdl_TripSAD.get('fSLat')?.value]"
                                        [dLonLat]="[mdl_TripSAD.get('fDLon')?.value,mdl_TripSAD.get('fDLat')?.value]"
                                        [strValue]="' مسیر ' + mdl_TripSAD.get('strSAddress')?.value + ' به ' + mdl_TripSAD.get('strDAddress')?.value "
                                        (mdl_Submit)="bRouteModal = false ">

                                    </app-custom-map>

                                </div>

                                <div *ngIf="strHelp != '' " class="alert alert-secondary w-100  mb-0 mt-3 text-center ">

                                    <span style="font-size: 13px!important;">

                                        {{ strHelp | faNum }}

                                    </span>

                                </div>

                            </div>

                        </ng-container>

                    </form>

                </div>

            </div>

        </div>
    </div>

    <img loading="lazy" src="../../../assets/imgs/Search-bar.png" alt="جستجو دیار">

    <div class="search-inner"></div>

</section>

<main class="main-container">

    <!-- بخش ویژه همکاران امدادران -->
    <section class="marketers  row gx-0 gy-0">

        <div class="col-md-12 my-4 central">

            <div class="container text-center">

                <div class="img-container text-center my-4">

                    <img loading="lazy" width="128px" src="../../../assets/imgs/handshake.png"
                        alt="آگهی های آماده به کار،استخدام راننده">

                </div>

                <h2 class="fw-bold"> بخش ویژه همکاران امدادران </h2>

                <p style="line-height: 40px;font-size: 16px;">

                    امدادران بستری حرفه‌ای برای ثبت و مدیریت درخواست‌های جرثقیل سیار فراهم کرده است. با استفاده از
                    فناوری
                    پیشرفته، درخواست‌ها به نزدیک‌ترین رانندگان ارسال می‌شود تا خدمات سریع و کارآمد ارائه شود. این سیستم
                    هم در زمان و هزینه صرفه‌جویی می‌کند و هم فرصت افزایش درآمد را برای همکاران فراهم می‌سازد.

                </p>

                <button class="btn btn-primary px-5 my-2 ">
                    <a href="/partners" target="_blank" class="w-100 h-100">
                        اطلاعات بیشتر
                    </a>
                </button>

            </div>

        </div>

    </section>

    <!-- امدادران، همراه شما در مسیرها با خدمات حرفه‌ای -->
    <section class="intercity-taxi w-100 my-4">

        <div class="row gx-0 gy-0 py-4 w-100">

            <div class="col-md-6 col-0"> </div>

            <div class="container col-md-6 col-12 p-md-2 p-3">

                <h1 class="fw-bold" style="font-size: 27px;line-height: 45px;"> امدادران، همراه شما در مسیرها با خدمات
                    حرفه‌ای امداد خودرو و جرثقیل سیار </h1>

                <p style="line-height: 37px;font-size: 15px;text-align: justify;" class="ps-md-5 px-2">

                    سامانه امدادران با هدف ارائه خدمات سریع، مطمئن و حرفه‌ای در حوزه امداد خودرو و جرثقیل سیار
                    راه‌اندازی
                    شده است. ما در هر لحظه و هر مکان، آماده‌ایم تا در صورت بروز مشکلاتی مانند خرابی خودرو، تصادفات یا
                    نیاز به حمل خودرو، به یاری شما بشتابیم.

                    با تیم متخصص و تجهیزات پیشرفته، امدادران بهترین خدمات را برای جابه‌جایی ایمن خودرو با جرثقیل سیار و
                    امداد فنی ارائه می‌دهد. کافی است به ما اعتماد کنید تا در کوتاه‌ترین زمان، بهترین راه‌حل‌ها را برای
                    شما فراهم کنیم.

                </p>

                <div class="col-12">

                    <button class="btn btn-primary px-5 mb-2 ">

                        <a href="/emdadran" target="_blank"> اطلاعات بیشتر &zwnj; </a>

                    </button>

                </div>

            </div>

        </div>

    </section>

    <!-- مراکز تعمیراتی، فروشگاه ها و خدماتی معتبر  -->
    <section class="marketers my-5 row gx-0 gy-0">

        <div class="col-md-12 my-4 central">

            <div class="container text-center">

                <div class="img-container text-center my-4">

                    <img loading="lazy" width="128px" src="../../../assets/imgs/repair-shop.png"
                        alt="مراکز تعمیراتی، فروشگاه ها و خدماتی معتبر ">

                </div>

                <h2 class="fw-bold"> پیدا کردن نزدیک‌ترین خدمات خودرویی، فقط با یک کلیک! </h2>

                <p style="line-height: 40px;font-size: 15px;">

                    در بخش مراکز تعمیرگاهی و فروشگاهی امدادران، می‌توانید به بانک اطلاعاتی کاملی از تعمیرگاه‌ها،
                    فروشگاه‌های قطعات خودرو و خدمات مرتبط، به تفکیک شهر و نوع خدمات دسترسی داشته باشید.

                    اگر در مسیر دچار مشکل شدید یا به دنبال نزدیک‌ترین تعمیرگاه یا فروشگاه هستید، کافی‌ است جستجو کنید تا
                    در کمترین زمان، خدمات مورد نیازتان را پیدا کنید.

                </p>

                <button class="btn btn-primary px-5 my-2 ">

                    <a href="/business" target="_blank">

                        مشاهده مراکز

                    </a>

                </button>

            </div>

        </div>

    </section>

    <!-- آگهی های مرتبط با امداد خودرو و جرثقیل سیار -->
    <section class="marketers my-5 row gx-0 gy-0" #adsContainer>

        <div *ngIf="obj_AppInfo?.bJobs" class="col-md-12 my-4 central">

            <div class="container text-center">

                <div class="img-container text-center my-4">

                    <img loading="lazy" width="128px" src="../../../assets/imgs/ads.png"
                        alt="آگهی های آماده به کار،استخدام راننده">

                </div>

                <h2 class="fw-bold"> آگهی های مرتبط با امداد خودرو و جرثقیل سیار </h2>

                <p style="line-height: 40px;font-size: 15px;">

                    در این بخش از امدادران، آگهی مرتبط با جرثقیل ثابت و سیار و خدمات مرتبط ارائه می گردد.

                </p>

                <ng-container *ngIf="lst_NewAds.length > 0">

                    <owl-carousel-o [options]="carouselOptions4News">

                        <ng-template *ngFor="let item of lst_NewAds" carouselSlide>

                            <div class="p-2 h-100" (click)="showAds(item)">

                                <div class="adds_box border border-2 h-100 p-1">

                                    <div class="img_box">

                                        <img loading="lazy"
                                            src="{{item.strImage != '' ? 'data:image/png;base64,' + item.strImage : '../../../assets/imgs/preview__thumbnail.png'}}"
                                            [title]="item.strTitle" alt="{{item.strTitle}}">

                                    </div>

                                    <div class="detail_box w-100 h-100" style="max-height: 70px!important;">

                                        <h3 class="fw-bold mx-0 mb-1 text-end" style="font-size: 13px;">
                                            {{subString_Title(item.strTitle,27) | faNum}}</h3>

                                        <div class="text-end">

                                            <span class="text-muted" style="font-size: 13px;">

                                                {{ item.strPublishTime }} در {{ item.strCityName }}

                                            </span>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </ng-template>

                    </owl-carousel-o>

                </ng-container>

                <button class="btn btn-primary px-5 my-2 ">

                    <a href="jobs" target="_blank">

                        مشاهده آگهی&zwnj;ها

                    </a>

                </button>

            </div>

        </div>

    </section>

    <!-- دعوت از رانندگان جرثقیل برای پیوستن به امدادران -->
    <section class="drivers-container my-4 about central justify-content-start">

        <div class="">

            <h2 style="font-size: 27px;" class="fw-bold"> دعوت از رانندگان جرثقیل برای پیوستن به امدادران </h2>

            <p style="line-height: 37px;font-size: 15px;" class="ps-md-5">

                اگر راننده جرثقیل هستید و به دنبال افزایش درآمد و مشتریان بیشتر می‌گردید، امدادران انتخابی عالی است! با
                عضویت در شبکه، به درخواست‌های امداد و حمل خودرو در منطقه خود دسترسی پیدا کرده و کسب‌وکار خود را گسترش
                دهید.

            </p>

            <button class="btn btn-primary px-5 mb-2 ">

                <a href="/drivers" target="_blank">

                    اطلاعات بیشتر&zwnj;

                </a>

            </button>

        </div>

    </section>

    <!-- نظرات کاربران -->
    <section class="feedback-container p-3 my-5" #feedbackContainer>

        <div class="container" *ngIf="obj_AppInfo?.bPassengerExperience">

            <ng-container *ngIf="lst_Feedback.length">
                <div class="central sec_title mb-2">
                    <h2 style="font-size: 22px;"> تجربه کاربران با امدادران
                        <span style="font-size: 15px;">
                            ({{ lst_Feedback.length | number:'1.0-0' | faNum }})
                        </span>
                    </h2>
                </div>

                <div class="row gx-0 gy-2 p-2">
                    <owl-carousel-o [options]="carouselOptions">
                        <ng-template *ngFor="let item of lst_Feedback" carouselSlide>
                            <div class="feedback-user w-100 p-2">
                                <div class="w-100 h-100 border border-2">
                                    <div class="feedback-header row gx-0 gy-0 w-100 border-bottom border-2 p-2">
                                        <div class="col-3 feedback-avatar">
                                            <img loading="lazy"
                                                src="{{item.strAvatar.trim() != '' ? 'data:image/png;base64,' + item.strAvatar : '../../../assets/imgs/avatar-default-icon.png' }}"
                                                alt="تصویر کاربر">
                                        </div>
                                        <span class="feedback-name pe-2 col-7"> {{ item.strName | faNum }} </span>

                                        <span dir="ltr" class="feedback-point col-3">

                                            <b style="font-size: 17px;">{{ item.tiDriverPoints | faNum}}</b>/{{'5' |
                                            faNum }}

                                        </span>

                                    </div>

                                    <div class="feedback-body">

                                        <article class="p-3">

                                            <span style="line-height: 25px;font-size: 12px;"> {{
                                                item.strPassengerOpinion |
                                                faNum }} </span>

                                        </article>

                                    </div>

                                    <div class="feedback-footer px-2 border-top border-2">

                                        <star-rating [starType]="'svg'" [rating]="item.tiDriverPoints" [size]="'small'">
                                        </star-rating>

                                        <span> {{ item.strDate | faNum}} </span>

                                    </div>

                                </div>
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
            </ng-container>

        </div>


    </section>

    <!-- ناوگان امدادران -->
    <section [ngClass]="obj_AppInfo?.bCurrentDriversLocation ? 'fleet-container' : ''" #fleetContainer>
        <ng-container *ngIf="obj_AppInfo?.bCurrentDriversLocation">
            <div class="container h-100 p-md-3 py-3 px-4 my-5">
                <div class="central sec_title mb-2">
                    <h3> پراکندگی لحظه‌ای جرثقیل‌ها </h3>
                </div>
                <app-custom-map *ngIf="lst_Drivers.length > 0" [isShowAll]="true"
                    [MARKER_ICON]="'../../../assets/imgs/box-truck.png'" [lst_Array]="lst_Drivers"
                    [lat_StrKey]="'dLatitude'" [lon_StrKey]="'dLongitude'"
                    [stylesArray]="['width: 100%','height: 500px','margin-bottom: 20px']">
                </app-custom-map>
            </div>
        </ng-container>
    </section>

    <!-- اخبار و نکات ایمنی خودرو و سفر -->
    <section [ngClass]="news.length > 0 ? 'py-3' : ''" #EventContainer>

        <div *ngIf="obj_AppInfo?.bNews" class="container">

            <ng-container *ngIf="news.length > 0">

                <div class="central sec_title my-5">

                    <h3> اخبار و نکات ایمنی خودرو و سفر </h3>

                </div>

                <owl-carousel-o [options]="carouselOptions4News">

                    <ng-template *ngFor="let item of news" carouselSlide>

                        <div (click)="openNews(item?.iNews)" class="p-2 h-100">

                            <div class="adds_box h-100">

                                <div class="img_box">

                                    <img loading="lazy" *ngIf="item.strImage"
                                        src="data:image/png;base64,{{item.strImage}}" [title]="item.strTitle"
                                        alt="{{item.strTitle}}">

                                    <img loading="lazy" *ngIf="!item.strImage"
                                        src="../../../assets/imgs/preview__thumbnail.png" alt="{{item.strTitle}}">

                                </div>

                                <div class="detail_box w-100 h-100" style="max-height: 70px!important;">

                                    <h3 class=" fw-bold mx-0 mb-1" style="font-size: 13px;">
                                        {{subString_Title(item.strTitle,60) | faNum}}</h3>

                                    <div class="text-start">

                                        <span class="text-muted" style="font-size: 13px;">{{
                                            item.strValidateDateAndTime}}</span>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </ng-template>

                </owl-carousel-o>

                <div class="central">

                    <button class="btn btn-primary my-3 ">

                        <a href="/news" target="_blank"> مشاهده بیشتر </a>

                    </button>

                </div>

            </ng-container>

        </div>


    </section>

    <!-- آموزش‌های حرفه‌ای -->
    <section [ngClass]="lst_Educations.length > 0 ? 'p-3 my-5' : ''" #EducationContainer>

        <div *ngIf="obj_AppInfo?.bProfessionalTraining" class="container">

            <div class="row gx-0 gy-2">

                <div class="central sec_title my-5">
                    <h3> آموزش‌های حرفه‌ای</h3>
                </div>

                <owl-carousel-o [options]="carouselOptions4News">

                    <ng-template *ngFor="let item of lst_Educations" class="col-md-4 col-12 p-3" carouselSlide>

                        <div class="card w-100">

                            <div class="video-container">

                                <iframe class="responsive-iframe" [src]="item.strContentPath" allowFullScreen="true"
                                    webkitallowfullscreen="true" mozallowfullscreen="true">

                                </iframe>

                            </div>

                            <div class="card-body">

                                <h4 class="card-title mb-1" style="height:51px;"> {{ subString_Title(item.strTitle,63) |
                                    faNum }} </h4>

                                <p class="card-text text-muted" style="height: 70px;"> {{
                                    subString_Title(item.strDetail,90) | faNum}} </p>

                            </div>

                        </div>

                    </ng-template>

                </owl-carousel-o>

                <div class="central">

                    <button class="btn btn-primary my-3 ">

                        <a href="/educations" target="_blank"> مشاهده بیشتر </a>

                    </button>

                </div>

            </div>

        </div>

    </section>

</main>

<!-- فوتر  -->

<app-footer></app-footer>

<!-- تبلیغات -->
<div class="modal  fade dir " id="modal" tabindex="4" role="dialog" style="z-index:100000 !important;">
    <div style="width:90%;" class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content bg-gray-soft">
            <div class="modal-body p-0 ">
                <button type="button" class="btn-close m-0 btn_close" data-bs-dismiss="modal"
                    aria-label="Close"></button>
                <div class="w-100 h-100">
                    <a class="w-100" target="_blank" href="{{popAds?.strURL}}"
                        (click)="popupClick(popAds.iDyar_PopupADV)">
                        <img loading="lazy" class="w-100" src="data:image/png;base64,{{popAds?.strIMage}}"
                            alt="{{popAds?.strTitle}}">
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>